// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file event/v1/order_event.proto (package event.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * The actual body of an order event message; the Order service may generate
 * multiple sub-types of order events.
 *
 * @generated from message event.v1.OrderEventPayload
 */
export const OrderEventPayload = proto3.makeMessageType(
  "event.v1.OrderEventPayload",
  () => [
    { no: 1, name: "merchant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sub_type", kind: "enum", T: proto3.getEnumType(OrderEventPayload_SubType) },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "origination", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "amount", kind: "scalar", T: 1 /* ScalarType.DOUBLE */ },
    { no: 7, name: "is_resubmitted", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "auth_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "capture_method", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "is_payment_succeeded", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from enum event.v1.OrderEventPayload.SubType
 */
export const OrderEventPayload_SubType = proto3.makeEnum(
  "event.v1.OrderEventPayload.SubType",
  [
    {no: 0, name: "SUB_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SUB_TYPE_CREATED", localName: "CREATED"},
    {no: 2, name: "SUB_TYPE_SUBMITTED", localName: "SUBMITTED"},
    {no: 3, name: "SUB_TYPE_PAYMENT_DONE", localName: "PAYMENT_DONE"},
  ],
);

